const DEFAULT_WIDTHS = {
    text: '10ch',
    heading: '14ch',
    sentence: '22ch',
    paragraph: '100%',
    chip: '8ch',
};

const hasDisplayValue = (value) => {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string') {
        return Boolean(value.trim());
    }
    if (typeof value === 'number') {
        return !Number.isNaN(value);
    }
    return true;
};

const ValueWithSkeleton = ({
    value,
    loading = false,
    fallback = 'Not provided',
    type = 'text',
    width,
    className = '',
}) => {
    const resolvedTypeClass = DEFAULT_WIDTHS[type] ? `app-skeleton-loader--${type}` : 'app-skeleton-loader--text';
    const resolvedWidth = width ?? DEFAULT_WIDTHS[type] ?? DEFAULT_WIDTHS.text;
    const classes = ['app-skeleton-loader', resolvedTypeClass, className]
        .filter(Boolean)
        .join(' ');

    if (loading) {
        return (
            <span
                className={classes}
                style={{ width: resolvedWidth }}
                aria-hidden="true"
            />
        );
    }

    if (hasDisplayValue(value)) {
        return <>{value}</>;
    }

    if (fallback === null) {
        return null;
    }

    return <>{fallback}</>;
};

export default ValueWithSkeleton;
